import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import { IRegisteredApplicant } from "../../model/applicant/RegisteredApplicant";
import GetApplicantsAppointmentsInteractor from "../../interactor/applicants/GetApplicantsAppointmentsInteractor";
import ApplicantsAppointmentPresentationModel, {
  TApplicantsAppointmentPresentationModel
} from "./model/ApplicantsAppointmentPresentationModel";
import ApplicantsAppointment, {
  IApplicantsAppointment
} from "../../model/applicant/ApplicantsAppointment";
import UpdateApplicantsAppointmentInteractor from "../../interactor/applicants/UpdateApplicantsAppointmentInteractor";
import { IPositionType } from "../../model/position/PositionType";
import CreateApplicantsAppointmentInteractor from "../../interactor/applicants/CreateApplicantsAppointmentInteractor";
import ShowSuccessMessageInteractor from "../../interactor/notifications/ShowSuccessMessageInteractor";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import GetApplicantRequestsInteractor from "../../interactor/requests/GetApplicantRequestsInteractor";
import GetApplicantReportingPeriodsInteractor from "../../interactor/applicants/GetApplicantReportingPeriodsInteractor";
import { IApplicantReportingPeriod } from "../../model/applicant/ApplicantReportingPeriod";
import { IReportingPeriodPermissionPresenter } from "../reporting/ReportingPeriodPermissionPresenter";
import ShowReportingPeriodPermissionsInteractor from "../../interactor/reporting/ShowReportingPeriodPermissionsInteractor";
import { IRequestType } from "../../model/request/RequestType";
import GetRequestTypesInteractor from "../../interactor/requests/GetRequestTypesInteractor";

import { RoleConstants } from "../../common/Constants";
import CreateRequestInteractor from "../../interactor/requests/CreateRequestInteractor";
import RequestPresentationModel, {
  TRequestPresentationModel
} from "../request/model/RequestPresentationModel";
import UpdateRequestInteractor from "../../interactor/requests/UpdateRequestInteractor";
import ApplicantReportingPeriodPresentationModel, {
  TApplicantReportingPeriodPresentationModel
} from "./model/ApplicantReportingPeriodPresentationModel";
import GetBoFormTypesInteractor from "../../interactor/form/GetBoFormTypesInteractor";
import ReportingPeriodFormTypePresentationModel, {
  TReportingPeriodFormTypePresentationModel
} from "../../model/form/mappers/ReportingPeriodFormTypeListMapper";
import BoFormVersionPresentationModel, {
  TBoFormVersionPresentationModel
} from "./model/BoFormVersionPresentationModel";
import GetBoFormVersionsInteractor from "../../interactor/form/GetBoFormVersionsInteractor";
import ShowReportingPeriodApplicantDocumentsInteractor from "../../interactor/reporting/ShowReportingPeriodApplicantDocumentsInteractor";
import MarkForAdditionalCheckInteractor from "../../interactor/applicants/MarkForAdditionCheckInteractor";
import UpdateStatusOfAdditionalCheckInteractor from "../../interactor/applicants/UpdateStatusOfAdditionalCheckInteractor";
import SetFormVersionForAnnouncementInteractor from "../../interactor/applicants/SetFormVersionForAnnouncementInteractor";
import {
  AdditionalCheckForAnnouncement,
  FormalCheckStatus
} from "../../common/Constants";
import UpdateElectronicRegistryNumberInteractor from "../../interactor/applicants/UpdateElectronicRegistryNumberInteractor";
import Request from "../../model/request/Request";
import ShowFormVersionEvaluationsInteractor from "../../interactor/evaluation/ShowFormVersionEvaluationsInteractor";
import { IFormVersionEvaluationsPresenter } from "../evaluation/FormVersionEvaluationsPresenter";
import AddBONewDraftFormVersionInteractor from "../../interactor/applicants/AddBONewDraftFormVersionInteractor";
import { IReportingPeriod } from "../../model/reporting/ReportingPeriod";
import SetFormalCheckStatusInteractor from "../../interactor/form/SetFormalCheckStatusInteractor";
import UpdateAdditionalEvaluationResultInteractor from "../../interactor/applicants/UpdateAdditionalEvaluationResultInteractor";
import GetAdditionalEvaluationResultInteractor from "../../interactor/applicants/GetAdditionalEvaluationResultInteractor";
import { IValueListItem } from "../../model/valuelist/ValueListItem";
import { IReportingPeriodApplicantDocumentsPresenter } from "../reporting/ReportingPeriodApplicantDocumentsPresenter";
import { IConfiguration } from "../../model/config/Configuration";
import { ApplicationService } from "../../service/ApplicationService";

export interface TRegisteredApplicantDetailsPresenter extends TLoadingAwarePresenter {
  applicant: IRegisteredApplicant;
  applicantsAppointments?: TApplicantsAppointmentPresentationModel[];
  currentApplicant?: IRegisteredApplicant;
  positionTypes: IPositionType[];
  requests: TRequestPresentationModel[];
  applicantReportingPeriodPermissions: IApplicantReportingPeriodPermissionPresentationModel[];
  requestTypes: IRequestType[];
  reportingPeriods: TApplicantReportingPeriodPresentationModel[];
  formTypes: TReportingPeriodFormTypePresentationModel[];
  formVersions: TBoFormVersionPresentationModel[];
  formVersionDocumentsPresenter?: IReportingPeriodApplicantDocumentsPresenter;
  modalVisible: TFormVersionModalVisible;
  formVersionDetails: TFormVersionDetailsPresentationModel;
  currentItem?: any;
  currentFormReportingPeriodId?: number;
  formVersionEvaluationsPresenter?: IFormVersionEvaluationsPresenter;
  reportingPeriodList?: IReportingPeriod[];
  reportingPeriodId?: number;
  expandedReportingPeriod?: IApplicantReportingPeriod;
  hasForms?: boolean;
  defaultTab?: string;
  additionalCheckStatusList: IValueListItem[];
  expandedFormType?: TReportingPeriodFormTypePresentationModel;
  configuration: IConfiguration;
  isSignedReportRequiredForAnnouncement: boolean;
}

export interface IRegisteredApplicantDetailsPresenter
  extends TRegisteredApplicantDetailsPresenter, TPresentable {
  loadApplicantDetails(
    applicant: IRegisteredApplicant,
    defaultTab?: string
  ): void;
  loadInitialData(
    positionTypes: IPositionType[],
    additionalCheckStatusList: IValueListItem[],
    configuration: IConfiguration,
    isSignedReportRequiredForAnnouncement: boolean
  ): void;
  getApplicantsAppointment(): void;
  createApplicantsAppointment(
    data: TApplicantsAppointmentPresentationModel
  ): void;
  updateApplicantsAppointment(
    data: TApplicantsAppointmentPresentationModel
  ): void;
  onChangeTab(key: string): void;
  onRowExpanded(expanded: any, record: IApplicantReportingPeriod): void;
  createRequest(request: TRequestPresentationModel): void;
  updateRequest(request: TRequestPresentationModel): void;
  onExpandReportingPeriod(expanded: any, record: any): void;
  onExpandFormType(expanded: any, record: any): void;
  onEvaluationsTabFormTypeExpanded(expanded: any, record: any): void;
  onDocumentsReportingPeriodExpanded(expanded: any, record: any): void;
  onChangeModalVisible(key: string, visible: boolean, record?: any): void;
  onChangeFormVersionDetails(key: string, value: string): void;
  markForAdditionalCheck(): void;
  updateStatusOfAdditionalCheck(): void;
  setFormVersionFormAnnouncement(): void;
  updateElectronicRegistryNumber(): void;
  onEvaluationsTabFormVersionExpanded(expanded: any, record: any): void;
  addNewDraftFormVersion(
    formTypeId: number,
    reportingPeriodApplicantId: number,
    applicantId?: number
  ): void;
  setReportingPeriodList(reportingPeriodList: IReportingPeriod[]): void;
  updateStatusOfFormalCheck(): void;
  updateAdditionalEvalutionResult(
    reportingPeriodApplicantId: number,
    result: string
  ): void;
  getAdditionalEvaluationResult(
    reportingPeriodApplicantId: number
  ): Promise<string | undefined>;
}

const defaultState: TRegisteredApplicantDetailsPresenter = {
  applicant: {} as IRegisteredApplicant,
  applicantsAppointments: [],
  currentApplicant: {} as IRegisteredApplicant,
  positionTypes: [],
  requests: [],
  reportingPeriods: [],
  applicantReportingPeriodPermissions: [],
  requestTypes: [],
  formTypes: [],
  formVersions: [],
  modalVisible: {} as TFormVersionModalVisible,
  formVersionDetails: {} as TFormVersionDetailsPresentationModel,
  reportingPeriodList: [],
  hasForms: undefined,
  defaultTab: "",
  additionalCheckStatusList: [],
  configuration: {} as IConfiguration,
  isSignedReportRequiredForAnnouncement: true
};

export interface TFormVersionDetailsPresentationModel {
  reasonAdditionalCheck?: string;
  statusAdditionalCheck?: string;
  forAnnouncement?: string;
  isAnnouncementVisible?: boolean;
  numberItemElectronicRegistry?: string;
  subNumberItemElectronicRegistry?: string;
  formalCheckStatus?: string;
}

export interface TFormVersionModalVisible {
  additionalCheck: boolean;
  statusAdditionalCheck: boolean;
  announcement: boolean;
  electronicRegistry: boolean;
  newEvaluation: boolean;
  formalCheck: boolean;
  obsoleteFormTypeAnnouncement: boolean;
}

function formatApplicantsAppointment(
  data: any,
  applicantId: number,
  applicantsAppointment?: IApplicantsAppointment
) {
  let appointment = applicantsAppointment || ApplicantsAppointment(data);
  appointment.applicantId = applicantId;
  appointment.positionTypeId = data.positionTypeId;
  appointment.description = data.description;

  return appointment;
}

export interface IApplicantReportingPeriodPermissionPresentationModel {
  reportingPeriod: IApplicantReportingPeriod;
  model: IReportingPeriodPermissionPresenter;
}

const ReportingPeriodPermissionPresentationModel = (
  reportingPeriod: IApplicantReportingPeriod,
  model: IReportingPeriodPermissionPresenter
) => {
  return {
    reportingPeriod: ApplicantReportingPeriodPresentationModel(reportingPeriod),
    model
  };
};
const RegisteredApplicantDetailsPresenter = withStore<
  IRegisteredApplicantDetailsPresenter,
  TRegisteredApplicantDetailsPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): IRegisteredApplicantDetailsPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TRegisteredApplicantDetailsPresenter>();

    loader.start("applicantLoader");
    loader.start("initialDataLoader");

    const loadApplicantDetails = (
      applicant: IRegisteredApplicant,
      defaultTab: string = "appointment"
    ) => {
      const { roles = [] } = _store.getState() as any;

      const usersTab =
        ApplicationService().hasAnyRole(
          [RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS],
          roles
        ) && !RoleConstants.MIK_BO_PDNS_ALLOWED_TABS.includes(defaultTab ?? "")
          ? RoleConstants.MIK_BO_PDNS_ALLOWED_TABS[0]
          : defaultTab;

      _store.update({
        applicant,
        defaultTab: usersTab
      });
      const loaderName = `${usersTab}Loader`;
      loader.start(loaderName);
      switch (usersTab) {
        case "requests": {
          updateRequests();
          updateRequestTypes();
          break;
        }
        case "reportingPeriods":
          updateReportingPeriods();
          break;
        case "permissions":
          updateReportingPeriodPermissions();
          break;
        case "evaluations":
          updateReportingPeriods();
          break;
        case "documents":
          updateReportingPeriods();
          break;
        case "form":
          updateReportingPeriods();
          break;
        case "appointment":
          getApplicantsAppointment();
          break;
        default:
          break;
      }

      loader.stop("applicantLoader");
      loader.stop(loaderName);
    };

    const loadInitialData = async (
      positionTypes: IPositionType[],
      additionalCheckStatusList: IValueListItem[],
      configuration: IConfiguration,
      isSignedReportRequiredForAnnouncement: boolean
    ) => {
      _store.update({
        positionTypes,
        additionalCheckStatusList,
        configuration,
        isSignedReportRequiredForAnnouncement
      });
      loader.stop("initialDataLoader");
    };

    const getApplicantsAppointment = async () => {
      loader.start("appointmentsLoader");
      const applicant =
        _store.getState<TRegisteredApplicantDetailsPresenter>().applicant;
      const applicantsAppointments = await _application.container
        .resolve<GetApplicantsAppointmentsInteractor>(
          "getApplicantsAppointments"
        )
        .execute(applicant.id);
      _store.update({
        applicantsAppointments: [
          ...applicantsAppointments.map(ApplicantsAppointmentPresentationModel)
        ]
      });
      loader.stop("appointmentsLoader");
    };

    const createApplicantsAppointment = async (data: any) => {
      try {
        const applicant =
          _store.getState<TRegisteredApplicantDetailsPresenter>().applicant;
        const applicantsAppointment = formatApplicantsAppointment(
          data,
          applicant.id
        );

        await _application.container
          .resolve<CreateApplicantsAppointmentInteractor>(
            "createApplicantsAppointment"
          )
          .execute(applicantsAppointment);

        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate(
              "applicant_appointment.messages.create_applicant_appointment_success"
            )
          );

        await getApplicantsAppointment();
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const updateApplicantsAppointment = async (applicantAppointment: any) => {
      try {
        await _application.container
          .resolve<UpdateApplicantsAppointmentInteractor>(
            "updateApplicantsAppointment"
          )
          .execute(applicantAppointment);

        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate(
              "applicant_appointment.messages.update_applicant_appointment_success"
            )
          );

        await getApplicantsAppointment();
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const onChangeTab = async (key: string) => {
      const applicantId =
        _store.getState<TRegisteredApplicantDetailsPresenter>().applicant.id;

      const { reportingPeriodId } =
        _store.getState<TRegisteredApplicantDetailsPresenter>();

      try {
        _store.update({
          reportingPeriods: [],
          applicantReportingPeriodPermissions: [],
          defaultTab: key
        });

        _application.navigator.push({
          pathname: reportingPeriodId
            ? `/reporting-periods/${reportingPeriodId}/registered-applicants/${applicantId}/details/${key}`
            : `/registered-applicants/${applicantId}/details/${key}`
        });
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const updateRequestTypes = async () => {
      let requestTypes = await _application.container
        .resolve<GetRequestTypesInteractor>("getRequestTypes")
        .execute();
      _store.update({ requestTypes });
    };

    const updateRequests = async () => {
      await updateReportingPeriods();
    };

    const getRequests = async (applicantReportingPeriodId: number) => {
      loader.start("requestLoader");
      let requests = await _application.container
        .resolve<GetApplicantRequestsInteractor>("getApplicantRequests")
        .execute(applicantReportingPeriodId);
      _store.update({
        requests: [...requests.map(RequestPresentationModel)]
      });
      loader.stop("requestLoader");
    };

    const onRowExpanded = async (
      expanded: any,
      record: IApplicantReportingPeriod
    ) => {
      if (expanded) {
        _store.update({ expandedReportingPeriod: record });
        await getRequests(record.id);
      }
    };

    const updateReportingPeriods = async () => {
      const state = _store.getState<TRegisteredApplicantDetailsPresenter>();
      const reportingPeriods = await _application.container
        .resolve<GetApplicantReportingPeriodsInteractor>(
          "getApplicantReportingPeriods"
        )
        .execute(state.applicant.id);
      _store.update({
        reportingPeriods: [
          ...reportingPeriods.map(ApplicantReportingPeriodPresentationModel)
        ]
      });
    };

    function formatRequest(data: any) {
      let requestRecord = Request(data);
      return requestRecord;
    }

    const createRequest = async (data: TRequestPresentationModel) => {
      try {
        const request = formatRequest(data);
        const expandedReportingPeriod =
          _store.getState<TRegisteredApplicantDetailsPresenter>()
            .expandedReportingPeriod;
        await _application.container
          .resolve<CreateRequestInteractor>("createRequest")
          .execute(request);
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate("applicantRequest_page.messages.create_request_success")
          );
        await getRequests(
          expandedReportingPeriod?.id ?? request.reportingPeriodApplicantId
        );
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const updateRequest = async (data: TRequestPresentationModel) => {
      try {
        const request = formatRequest(data);
        const expandedReportingPeriod =
          _store.getState<TRegisteredApplicantDetailsPresenter>()
            .expandedReportingPeriod;
        await _application.container
          .resolve<UpdateRequestInteractor>("updateRequest")
          .execute(request);
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate("applicantRequest_page.messages.update_request_success")
          );
        await getRequests(
          expandedReportingPeriod?.id ?? request.reportingPeriodApplicantId
        );
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const getExpnadedRowData = async (reportingPeriodApplicantId: number) => {
      loader.start("boFormTypesLoader");

      await getBoFormTypes(reportingPeriodApplicantId);

      loader.stop("boFormTypesLoader");
    };

    const getBoFormTypes = async (reportingPeriodApplicantId: number) => {
      try {
        let formTypes = await _application.container
          .resolve<GetBoFormTypesInteractor>("getBoFormTypes")
          .execute(reportingPeriodApplicantId);

        _store.update({
          formTypes: [
            ...formTypes.map((item) =>
              ReportingPeriodFormTypePresentationModel(item)
            )
          ]
        });
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const onExpandReportingPeriod = (expanded: any, record: any) => {
      if (expanded) {
        getExpnadedRowData(record.id);
      }
    };

    const getExpandedFormTypeRowData = async (
      formReportingPeriodId?: number
    ) => {
      loader.start("boFormVersionsLoader");

      _store.update({
        currentFormReportingPeriodId: formReportingPeriodId
      });
      await getBoFormVersions(formReportingPeriodId);

      loader.stop("boFormVersionsLoader");
    };

    const getBoFormVersions = async (formReportingPeriodId?: number) => {
      try {
        if (formReportingPeriodId) {
          let formTypes = await _application.container
            .resolve<GetBoFormVersionsInteractor>("getBoFormVersions")
            .execute(formReportingPeriodId);
          _store.update({
            formVersions: [...formTypes.map(BoFormVersionPresentationModel)]
          });
        } else {
          _store.update({
            formVersions: []
          });
        }
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const onExpandFormType = (expanded: any, record: any) => {
      if (expanded) {
        _store.update({ expandedFormType: record });
        getExpandedFormTypeRowData(record.formReportingPeriodId);
      } else {
        _store.update({ expandedFormType: undefined });
      }
    };

    const onEvaluationsTabFormTypeExpanded = (expanded: any, record: any) => {
      if (expanded) {
        getExpandedFormTypeRowData(record.formReportingPeriodId);
        const formVersionEvaluationsPresenter = _application.container
          .resolve<ShowFormVersionEvaluationsInteractor>(
            "showFormVersionEvaluations"
          )
          .execute(record.id);
        _store.update({
          formVersionEvaluationsPresenter
        });
      }
    };
    const updateReportingPeriodPermissions = async () => {
      const state = _store.getState<TRegisteredApplicantDetailsPresenter>();
      const reportingPeriods = await _application.container
        .resolve<GetApplicantReportingPeriodsInteractor>(
          "getApplicantReportingPeriods"
        )
        .execute(state.applicant.id);
      const applicantReportingPeriodPermissions = (reportingPeriods || []).map(
        (item) => {
          return ReportingPeriodPermissionPresentationModel(
            item,
            _application.container
              .resolve<ShowReportingPeriodPermissionsInteractor>(
                "showReportingPeriodPermissions"
              )
              .execute(item.id, state.applicant.id)
          );
        }
      );
      _store.update({
        applicantReportingPeriodPermissions
      });
    };

    const onDocumentsReportingPeriodExpanded = async (
      expanded: any,
      record: any
    ) => {
      if (expanded) {
        const formVersionDocumentsPresenter = _application.container
          .resolve<ShowReportingPeriodApplicantDocumentsInteractor>(
            "showReportingPeriodApplicantDocuments"
          )
          .execute(record.id);

        _store.update({ formVersionDocumentsPresenter });
      }
    };

    const onChangeModalVisible = async (
      key: string,
      visible: boolean,
      record?: any
    ) => {
      let modalVisible =
        _store.getState<TRegisteredApplicantDetailsPresenter>().modalVisible;
      let formVersionDetails =
        _store.getState<TRegisteredApplicantDetailsPresenter>()
          .formVersionDetails;
      const { isSignedReportRequiredForAnnouncement } =
        _store.getState<TRegisteredApplicantDetailsPresenter>();
      modalVisible[key] = visible;

      if (key === "obsoleteFormTypeAnnouncement") {
        record =
          _store.getState<TRegisteredApplicantDetailsPresenter>().currentItem;
      }

      if (record) {
        if (key === "electronicRegistry") {
          formVersionDetails.numberItemElectronicRegistry =
            record.numberItemElectronicRegistry;
          formVersionDetails.subNumberItemElectronicRegistry =
            record.subNumberItemElectronicRegistry;
        }
        if (key === "announcement") {
          formVersionDetails.forAnnouncement = record.forPublication
            ? AdditionalCheckForAnnouncement.YES
            : AdditionalCheckForAnnouncement.NO;

          formVersionDetails.isAnnouncementVisible =
            record.formalCheckStatus === true &&
            !(isSignedReportRequiredForAnnouncement && !record.digitallySigned);
        }
        if (key === "formalCheck") {
          if (record.formalCheckStatus !== undefined) {
            formVersionDetails.formalCheckStatus =
              record.formalCheckStatus === true
                ? FormalCheckStatus.ACCEPT
                : FormalCheckStatus.REJECT;
          } else {
            formVersionDetails.formalCheckStatus = FormalCheckStatus.ACCEPT;
            onChangeFormVersionDetails(
              "formalCheckStatus",
              FormalCheckStatus.ACCEPT
            );
          }
        }
        if (key === "additionalCheck" || key === "statusAdditionalCheck") {
          if (key === "statusAdditionalCheck") {
            formVersionDetails.statusAdditionalCheck =
              record.evaluationStatus ?? undefined;
          }
          const formTypes = await _application.container
            .resolve<GetBoFormTypesInteractor>("getBoFormTypes")
            .execute(record.id);
          _store.update({
            hasForms: formTypes?.length >= 1
          });
        }
        if (key === "newEvaluation") {
          const formVersionEvaluationsPresenter =
            _store.getState<TRegisteredApplicantDetailsPresenter>()
              .formVersionEvaluationsPresenter;
          formVersionEvaluationsPresenter?.setFormVersionId(record.id);
          _store.update({ formVersionEvaluationsPresenter });
        }
      }

      _store.update({
        modalVisible,
        currentItem: record,
        formVersionDetails
      });
    };

    const onChangeFormVersionDetails = (key: string, value: string) => {
      let formVersionDetails =
        _store.getState<TRegisteredApplicantDetailsPresenter>()
          .formVersionDetails;

      formVersionDetails[key] = value;
      _store.update({
        formVersionDetails
      });
    };

    const markForAdditionalCheck = async () => {
      try {
        let state = _store.getState<TRegisteredApplicantDetailsPresenter>();
        const reason = state.formVersionDetails.reasonAdditionalCheck;
        state.currentItem &&
          (await application.container
            .resolve<MarkForAdditionalCheckInteractor>("markForAdditionalCheck")
            .execute(state.currentItem.id, reason));
        state.modalVisible.additionalCheck = false;
        state.formVersionDetails.reasonAdditionalCheck = undefined;
        _store.update({
          modalVisible: state.modalVisible,
          formVersionDetails: state.formVersionDetails
        });

        await updateReportingPeriods();

        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate("applicantForms_page.messages.additional_check_success")
          );
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const updateStatusOfAdditionalCheck = async () => {
      try {
        let state = _store.getState<TRegisteredApplicantDetailsPresenter>();
        const status = state.formVersionDetails.statusAdditionalCheck;
        state.currentItem &&
          (await application.container
            .resolve<UpdateStatusOfAdditionalCheckInteractor>(
              "updateStatusOfAdditionalCheck"
            )
            .execute(state.currentItem.id, status));
        state.modalVisible.statusAdditionalCheck = false;
        state.formVersionDetails.statusAdditionalCheck = undefined;
        _store.update({
          modalVisible: state.modalVisible,
          formVersionDetails: state.formVersionDetails
        });

        await updateReportingPeriods();

        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate(
              "applicantForms_page.messages.status_additional_check_success"
            )
          );
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const setFormVersionFormAnnouncement = async () => {
      try {
        let state = _store.getState<TRegisteredApplicantDetailsPresenter>();
        const forAnnouncement = state.formVersionDetails.forAnnouncement;
        state.currentItem &&
          (await application.container
            .resolve<SetFormVersionForAnnouncementInteractor>(
              "setFormVersionForAnnouncement"
            )
            .execute(state.currentItem.id, forAnnouncement));
        state.modalVisible.obsoleteFormTypeAnnouncement = false;
        state.modalVisible.announcement = false;
        state.formVersionDetails.forAnnouncement = undefined;
        state.formVersionDetails.isAnnouncementVisible = undefined;
        _store.update({
          modalVisible: state.modalVisible,
          formVersionDetails: state.formVersionDetails
        });
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate(
              "applicantForms_page.messages.announcement_form_version_success"
            )
          );

        await getBoFormVersions(state.currentFormReportingPeriodId);
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const updateElectronicRegistryNumber = async () => {
      try {
        let state = _store.getState<TRegisteredApplicantDetailsPresenter>();
        const numberItemElectronicRegistry =
          state.formVersionDetails.numberItemElectronicRegistry;
        const subNumberItemElectronicRegistry =
          state.formVersionDetails.subNumberItemElectronicRegistry;
        state.currentItem.id &&
          (await application.container
            .resolve<UpdateElectronicRegistryNumberInteractor>(
              "updateElectronicRegistryNumber"
            )
            .execute(
              state.currentItem.id,
              numberItemElectronicRegistry,
              subNumberItemElectronicRegistry
            ));
        state.modalVisible.electronicRegistry = false;
        state.formVersionDetails.numberItemElectronicRegistry = undefined;
        state.formVersionDetails.subNumberItemElectronicRegistry = undefined;
        _store.update({
          modalVisible: state.modalVisible,
          formVersionDetails: state.formVersionDetails
        });
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate(
              "applicantForms_page.messages.electronic_registry_success"
            )
          );

        await getBoFormVersions(state.currentFormReportingPeriodId);
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const onEvaluationsTabFormVersionExpanded = async (
      expanded: any,
      record: any
    ) => {
      if (expanded) {
        const formVersionEvaluationsPresenter = _application.container
          .resolve<ShowFormVersionEvaluationsInteractor>(
            "showFormVersionEvaluations"
          )
          .execute(record.id);
        _store.update({ formVersionEvaluationsPresenter });
      }
    };

    const addNewDraftFormVersion = async (
      formTypeId: number,
      reportingPeriodApplicantId: number,
      applicantId?: number
    ) => {
      const { configuration } =
        _store.getState<IRegisteredApplicantDetailsPresenter>();

      let { formTypes } =
        _store.getState<IRegisteredApplicantDetailsPresenter>();

      try {
        startAddNewDraftFromVersionLoader(formTypes, formTypeId);
        const response = await application.container
          .resolve<AddBONewDraftFormVersionInteractor>(
            "addBONewDraftFormVersion"
          )
          .execute(reportingPeriodApplicantId, formTypeId);

        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate("applicantForms_page.messages.form_version_success")
          );
        await getBoFormTypes(reportingPeriodApplicantId);

        formTypes =
          _store.getState<IRegisteredApplicantDetailsPresenter>().formTypes;

        const formType = formTypes.find(
          (formType) => formType.id === formTypeId
        );

        formType &&
          window.open(
            `${configuration.frontOfficeUrl}/reporting-periods/${reportingPeriodApplicantId}/forms/${formType.id}/details?version=${response.version}&applicantId=${applicantId}`,
            "_blank"
          );
      } catch (error) {
        stopAddNewDraftFromVersionLoader(formTypes, formTypeId);
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const startAddNewDraftFromVersionLoader = (
      formTypes: TReportingPeriodFormTypePresentationModel[],
      formTypeId: number
    ) => {
      _store.update({
        formTypes: setAddNewDraftFromVersionLoader(formTypes, formTypeId, true)
      });
    };

    const stopAddNewDraftFromVersionLoader = (
      formTypes: TReportingPeriodFormTypePresentationModel[],
      formTypeId: number
    ) => {
      _store.update({
        formTypes: setAddNewDraftFromVersionLoader(formTypes, formTypeId, false)
      });
    };

    const setAddNewDraftFromVersionLoader = (
      formTypes: TReportingPeriodFormTypePresentationModel[],
      formTypeId: number,
      loading: boolean
    ) => {
      return formTypes.map(
        (formType: TReportingPeriodFormTypePresentationModel) => {
          if (formType.id === formTypeId) {
            formType.addNewDraftVersionLoader = loading;
          }
          return formType;
        }
      );
    };

    const onRenderBreadcrumbLabel = (id: string) => {
      let state = _store.getState<TRegisteredApplicantDetailsPresenter>();
      return state.applicant.name;
    };
    const onRenderTabLabel = (id: string) => {
      let tab =
        _store.getState<TRegisteredApplicantDetailsPresenter>().defaultTab;
      return translate(`pages.${tab}`);
    };
    const reportingPeriodBreadcrumbLabel = () => {
      let state = _store.getState<TRegisteredApplicantDetailsPresenter>();
      let reportingPeriod = state.reportingPeriodList?.find(
        (item: IReportingPeriod) => item.id === state.reportingPeriodId
      );
      return reportingPeriod?.name;
    };

    const setReportingPeriodList = (
      reportingPeriodList: IReportingPeriod[]
    ) => {
      _store.update({
        reportingPeriodList
      });
    };

    _store.update({
      breadCrumb: {
        ...(_store.getState() as any).breadCrumb,
        applicantId: onRenderBreadcrumbLabel,
        reportingPeriodId: reportingPeriodBreadcrumbLabel,
        tabKey: onRenderTabLabel
      }
    });

    const updateStatusOfFormalCheck = async () => {
      try {
        let state = _store.getState<TRegisteredApplicantDetailsPresenter>();
        const status = state.formVersionDetails.formalCheckStatus;
        state.currentItem &&
          status &&
          (await application.container
            .resolve<SetFormalCheckStatusInteractor>("setFormalCheckStatus")
            .execute(state.currentItem.id, status));
        state.modalVisible.formalCheck = false;
        state.formVersionDetails.formalCheckStatus = undefined;
        _store.update({
          modalVisible: state.modalVisible,
          formVersionDetails: state.formVersionDetails
        });
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate(
              "applicantForms_page.messages.status_formal_check_success"
            )
          );
        await getBoFormVersions(state.currentFormReportingPeriodId);
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const updateAdditionalEvalutionResult = async (
      reportingPeriodApplicantId: number,
      result: string
    ) => {
      try {
        await _application.container
          .resolve<UpdateAdditionalEvaluationResultInteractor>(
            "updateAdditionalEvaluationResult"
          )
          .execute(reportingPeriodApplicantId, result);
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(
            translate("additional_evaluation_result_form.success_message")
          );
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const getAdditionalEvaluationResult = async (
      reportingPeriodApplicantId: number
    ) => {
      try {
        const result = await _application.container
          .resolve<GetAdditionalEvaluationResultInteractor>(
            "getAdditionalEvaluationResult"
          )
          .execute(reportingPeriodApplicantId);
        return result;
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadApplicantDetails,
      loadInitialData,
      createRequest,
      getApplicantsAppointment,
      createApplicantsAppointment,
      updateApplicantsAppointment,
      onChangeTab,
      updateRequest,
      onRowExpanded,
      onExpandReportingPeriod,
      onExpandFormType,
      onEvaluationsTabFormTypeExpanded,
      onDocumentsReportingPeriodExpanded,
      onChangeModalVisible,
      onChangeFormVersionDetails,
      markForAdditionalCheck,
      updateStatusOfAdditionalCheck,
      setFormVersionFormAnnouncement,
      updateElectronicRegistryNumber,
      onEvaluationsTabFormVersionExpanded,
      addNewDraftFormVersion,
      setReportingPeriodList,
      updateStatusOfFormalCheck,
      updateAdditionalEvalutionResult,
      getAdditionalEvaluationResult
    };
  },
  defaultState
);

export default RegisteredApplicantDetailsPresenter;
